import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { ActivityLogChangesetPayload, Changeset, formatAttribute, formatData, formatValue } from './common';
import { getTemplateUpdatedValue } from './templateRenderers';

const useGetActivityLogChangesetQuery = (changesetId?: string) => {
  const { data, isLoading } = useQuery(
    // TODO: the type is missing
    [API_URL.ACTIVITY_LOGS_BY_CHANGESET_ID(changesetId || '')],
    () => api.get<ActivityLogChangesetPayload[]>(API_URL.ACTIVITY_LOGS_BY_CHANGESET_ID(changesetId || '')),
    {
      enabled: Boolean(changesetId),
      onError: () => {},
    }
  );
  const formattedData = useMemo(
    () =>
      formatData(data?.data || [])?.map(
        (item): Changeset => ({
          id: item?.id,
          changesetId,
          attribute: formatAttribute(item.fieldName),
          previous: formatValue(item.fieldName, item.oldValue),
          updated: formatValue(item.fieldName, item.newValue),
          updatedNode: getTemplateUpdatedValue(item),
        })
      ),
    [data, changesetId]
  );
  return {
    formattedData,
    isLoading,
  };
};

export default useGetActivityLogChangesetQuery;
